/**
 * consoleを出力しないようにする
 * @param {boolean} isDebug
 * */
export function setupConsoleForDebug(isDebug) {
    const noop = () => {}
    const consoleMethods = ['log', 'error', 'warn','debug']

    if (!window.console) {
        window.console = {}
    }

    consoleMethods.forEach((method) => {
        if (typeof window.console[method] !== 'function' || !isDebug) {
            window.console[method] = noop
        }
    })
}
